module.exports = __webpack_public_path__ + "img/alerts.ffe58d46.svg";